const d = '.sl-card{display:flex;flex-direction:column;background:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-foreground));border-radius:var(--sl-radius-lg);overflow:hidden}.sl-card--bordered{border:1px solid hsl(var(--sl-hsl-border))}.sl-card--shadow{box-shadow:var(--sl-shadow-md)}.sl-card--no-padding .sl-card__body{padding:0}.sl-card--sm .sl-card__body{padding:var(--sl-spacing-3)}.sl-card--lg .sl-card__body{padding:var(--sl-spacing-8)}.sl-card__header{display:flex;align-items:center;justify-content:space-between;padding:var(--sl-spacing-4) var(--sl-spacing-6);border-bottom:1px solid hsl(var(--sl-hsl-border))}.sl-card__header[hidden],.sl-card__media[hidden],.sl-card__actions[hidden],.sl-card__footer[hidden]{display:none}.sl-card__media{display:block;width:100%;aspect-ratio:16 / 9;object-fit:cover;background:hsl(var(--sl-hsl-muted))}slot[name="media"]::slotted(img){width:100%;height:100%;object-fit:cover;display:block}.sl-card__body{flex:1;padding:var(--sl-spacing-6)}.sl-card__actions{display:flex;align-items:center;gap:var(--sl-spacing-2);padding:var(--sl-spacing-4) var(--sl-spacing-6);border-top:1px solid hsl(var(--sl-hsl-border))}.sl-card__footer{display:flex;align-items:center;justify-content:flex-end;gap:var(--sl-spacing-2);padding:var(--sl-spacing-4) var(--sl-spacing-6);border-top:1px solid hsl(var(--sl-hsl-border));background:hsl(var(--sl-hsl-muted))}@media (max-width:640px){.sl-card__header,.sl-card__body,.sl-card__actions,.sl-card__footer{padding:var(--sl-spacing-4)}}';
class a extends HTMLElement {
  static get observedAttributes() {
    return ["shadow", "bordered", "padding"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._updateSlotVisibilityBound = this._updateSlotVisibility.bind(this), this._render();
  }
  connectedCallback() {
    this._addSlotListeners();
  }
  disconnectedCallback() {
    this._removeSlotListeners();
  }
  attributeChangedCallback(s, e, t) {
    e !== t && (this._removeSlotListeners(), this._render(), this.isConnected && this._addSlotListeners());
  }
  get shadow() {
    return this.hasAttribute("shadow");
  }
  set shadow(s) {
    s ? this.setAttribute("shadow", "") : this.removeAttribute("shadow");
  }
  get bordered() {
    return !this.hasAttribute("bordered") || this.hasAttribute("bordered") && this.getAttribute("bordered") !== "false";
  }
  set bordered(s) {
    s ? this.setAttribute("bordered", "true") : this.setAttribute("bordered", "false");
  }
  get padding() {
    return this.getAttribute("padding") || "md";
  }
  set padding(s) {
    this.setAttribute("padding", s);
  }
  _getCardClasses() {
    const s = ["sl-card"];
    return this.shadow && s.push("sl-card--shadow"), this.bordered && s.push("sl-card--bordered"), this.padding === "none" ? s.push("sl-card--no-padding") : this.padding !== "md" && s.push(`sl-card--${this.padding}`), s.join(" ");
  }
  _updateSlotVisibility(s) {
    const e = s.target;
    e.toggleAttribute("hidden", e.assignedNodes().length === 0);
  }
  _addSlotListeners() {
    this._shadow.querySelectorAll("slot[name]").forEach((e) => {
      e.addEventListener("slotchange", this._updateSlotVisibilityBound), e.toggleAttribute("hidden", e.assignedNodes().length === 0);
    });
  }
  _removeSlotListeners() {
    this._shadow.querySelectorAll("slot[name]").forEach((e) => {
      e.removeEventListener("slotchange", this._updateSlotVisibilityBound);
    });
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${d}</style>
      <div class="${this._getCardClasses()}">
        <slot name="header" class="sl-card__header"></slot>
        <slot name="media" class="sl-card__media"></slot>
        <div class="sl-card__body">
          <slot></slot>
        </div>
        <slot name="actions" class="sl-card__actions"></slot>
        <slot name="footer" class="sl-card__footer"></slot>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-card") && customElements.define("sl-card", a);
export {
  a as SlCardElement
};
//# sourceMappingURL=sl-card.js.map
